import { styled, Typography, TypographyProps } from '@mui/material'

export const Callout = styled(Typography)<TypographyProps>(({ theme }) => ({
  padding: `0.8em ${theme.spacing(1.5)} 1em ${theme.spacing(1)}`,
  // borderRadius: theme.shape.borderRadius,
  borderLeft: `6px solid ${theme.palette.primary.main}`,
  color: theme.palette.text.primary,
  background: 'rgba(192, 192, 192, 0.15)',
}))
